import { LocationObject } from "/server/parse-location.js";

export async function toastStoreOpen(date) {

    var open = false;

    const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
    var diningBehavior = 'TAKE_OUT';
    if (deliveryBool == true) {
        diningBehavior = 'DELIVERY';
    }

    var orderSchedule = JSON.parse(localStorage.getItem('toastOrderSchedule'));
    if (orderSchedule == null) {

        const locationObject = await LocationObject();
        const restaurantGuid = locationObject.get('guid');

        const toastLocation = await Parse.Cloud.run('getToastLocation', {'restaurantGuid': restaurantGuid});
        localStorage.setItem('toastLocation', JSON.stringify(toastLocation.get('object')));

        const toastOrderSchedule = await Parse.Cloud.run('getToastOrderSchedule', {'restaurantGuid': restaurantGuid});
        localStorage.setItem('toastOrderSchedule', JSON.stringify(toastOrderSchedule.get('object')));
        orderSchedule = toastOrderSchedule.get('object');
    }

    const servicePeriods = orderSchedule.servicePeriods;
    
    const servicePeriod = servicePeriods.find(obj => obj.diningOptionBehavior === diningBehavior);
    if (servicePeriod != null) {

        const dayPeriods = servicePeriod.dayPeriods;
        
        const options = { weekday: 'long' };
        const dayCaps = date.toLocaleDateString('en-US', options).toUpperCase();

        const currentPeriod = dayPeriods.find(obj => obj.day === dayCaps);
        
        if (currentPeriod != null) {

            let timeRange = currentPeriod.timeRanges[0];
            
            let startTime = timeRange.start;
            let endTime = timeRange.end;

            const startDate = new Date(date);
            
            const startHour = Number(startTime.substring(0, 2));
            const startMinute = Number(startTime.substring(startTime.length - 2));

            startDate.setHours(startHour, startMinute, 0, 0);
            
            const endDate = new Date(date);
            const endHour = Number(endTime.substring(0, 2));
            const endMinute = Number(endTime.substring(endTime.length - 2));

            endDate.setHours(endHour, endMinute, 0, 0);
            
            const lastOrderConfiguration = orderSchedule.lastOrderConfiguration;
            if (lastOrderConfiguration == "UNTIL_PREPTIME_CUTOFF") {

                var cutoffKey = "deliveryPrepTime";
                if (diningBehavior == "TAKE_OUT") {
                    cutoffKey = "takeoutPrepTime";
                }
                const toastLocation = JSON.parse(localStorage.getItem('toastLocation'));
                if (toastLocation != null) {
                    const prepTime = toastLocation.prepTimes[cutoffKey];
                    let difference = endDate.getMinutes() - prepTime;
                    endDate.setMinutes(difference);
                }
            } 
            if (date > startDate && date < endDate) {
                return true;
            }
        }
    }
    return false;
}

export function getOpenTime(date) {

    const orderSchedule = JSON.parse(localStorage.getItem('toastOrderSchedule'));
    const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
    var diningBehavior = 'TAKE_OUT';
    if (deliveryBool) {
        diningBehavior = 'DELIVERY';
    }

    const servicePeriods = orderSchedule.servicePeriods;
    const servicePeriod = servicePeriods.find(obj => obj.diningOptionBehavior === diningBehavior);
    if (servicePeriod != null) {

        const dayPeriods = servicePeriod.dayPeriods;
        
        const options = { weekday: 'long' };
        const dayCaps = date.toLocaleDateString('en-US', options).toUpperCase();

        const currentPeriod = dayPeriods.find(obj => obj.day === dayCaps);
        
        if (currentPeriod != null) {

            let timeRange = currentPeriod.timeRanges[0];
            
            let startTime = timeRange.start;
            
            const startHour = Number(startTime.substring(0, 2));
            const startMinute = Number(startTime.substring(startTime.length - 2));

            const startDate = new Date(date);
            startDate.setHours(startHour, startMinute, 0, 0);

            return startDate;
        }
    }
}

export function getCloseTime(date) {

    const orderSchedule = JSON.parse(localStorage.getItem('toastOrderSchedule'));
    const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
    var diningBehavior = 'TAKE_OUT';
    if (deliveryBool) {
        diningBehavior = 'DELIVERY';
    }

    const servicePeriods = orderSchedule.servicePeriods;
    const servicePeriod = servicePeriods.find(obj => obj.diningOptionBehavior === diningBehavior);
    if (servicePeriod != null) {

        const dayPeriods = servicePeriod.dayPeriods;
        
        const options = { weekday: 'long' };
        const dayCaps = date.toLocaleDateString('en-US', options).toUpperCase();

        const currentPeriod = dayPeriods.find(obj => obj.day === dayCaps);
        
        if (currentPeriod != null) {

            let timeRange = currentPeriod.timeRanges[0];
            
            let endTime = timeRange.end;

            const endDate = new Date(date);
            const endHour = Number(endTime.substring(0, 2));
            const endMinute = Number(endTime.substring(endTime.length - 2));

            endDate.setHours(endHour, endMinute, 0, 0);

            return endDate;
        }
    }
}

export function getRestaurantOpenStatus(date = new Date()) {

    const restaurant = JSON.parse(localStorage.getItem("toastOrderSchedule"));
    const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
    var diningOption = 'TAKE_OUT';
    if (deliveryBool == true)  {diningOption = 'DELIVERY'; }

    const tz = restaurant.timeZoneId || "America/New_York";
    const toLocal = (d) => new Date(d.toLocaleString("en-US", { timeZone: tz }));
    const localNow = toLocal(date);

    const dayNames = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
    const currentDayIndex = localNow.getDay();
    const currentDayName = dayNames[currentDayIndex];

    const minutesNow = localNow.getHours() * 60 + localNow.getMinutes();

    const servicePeriod = restaurant.servicePeriods.find(
        (sp) => sp.diningOptionBehavior === diningOption
    );
    if (!servicePeriod) {
        return {
        isOpen: false,
        nextOpenTime: null,
        nextCloseTime: null,
        message: `${diningOption} not available.`
        };
    }

    const orderedDays = [...dayNames.slice(currentDayIndex), ...dayNames.slice(0, currentDayIndex)];

    const cutoffType = restaurant.lastOrderConfiguration || "UNTIL_CLOSING_TIME";
    const cutoffMinutes = restaurant.cutoffTimeMinutes || 0;

    let isOpen = false;
    let nextOpenTime = null;
    let nextCloseTime = null;

    for (let i = 0; i < orderedDays.length; i++) {
        const day = orderedDays[i];
        const dayPeriod = servicePeriod.dayPeriods.find((dp) => dp.day === day);
        if (!dayPeriod) continue;

        for (const range of dayPeriod.timeRanges || []) {
        let [startHour, startMin] = range.start.split(":").map(Number);
        let [endHour, endMin] = range.end.split(":").map(Number);

        let startMinutes = startHour * 60 + startMin;
        let endMinutes = endHour * 60 + endMin;

        // Apply cutoff window
        if (cutoffType === "MINUTES_BEFORE_CLOSING") {
            endMinutes -= cutoffMinutes;
            if (endMinutes < startMinutes) continue; // invalid if cutoff crosses boundary
        }

        const dayOffset = i;
        const startDate = new Date(localNow);
        const endDate = new Date(localNow);
        startDate.setDate(localNow.getDate() + dayOffset);
        endDate.setDate(localNow.getDate() + dayOffset);
        startDate.setHours(startHour, startMin, 0, 0);
        endDate.setHours(endHour, endMin, 0, 0);

        if (i === 0 && minutesNow >= startMinutes && minutesNow < endMinutes) {
            isOpen = true;
            nextCloseTime = endDate;
        } else if (!isOpen && (i > 0 || minutesNow < startMinutes)) {
            if (!nextOpenTime) {
            nextOpenTime = startDate;
            }
            break;
        }
        }

        if (isOpen || nextOpenTime) break;
    }

    const message = isOpen
        ? `Open now (for orders), closes at ${nextCloseTime.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            timeZone: tz
        })}`
        : nextOpenTime
        ? `Closed now - Opens ${nextOpenTime.toLocaleDateString("en-US", {
            weekday: "short",
            hour: "numeric",
            minute: "2-digit",
            timeZone: tz
        })}`
        : "Closed today";

    return { isOpen, nextOpenTime, nextCloseTime, message };
}